module.exports = __webpack_public_path__ + "hk.svg?df295e8678086ce1f1b4785bb6a3f29c";